module.exports = __webpack_public_path__ + "img/awm17cm.a7919881.jpg";